/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_Seating_Add_PlayerInputs */



/**
* | output |
* | --- |
* | "Add a player ({count})" |
*
* @param {Rounds_Seating_Add_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_add_player = /** @type {((inputs: Rounds_Seating_Add_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_Add_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajouter un joueur (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadir un jugador (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Adicionar um jogador (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiungi un giocatore (${i?.count})`)
	return /** @type {LocalizedString} */ (`Add a player (${i?.count})`)
});